const Container = ({ children, noBorder }) => (
  <div className="bg-wide-sc">
    <main className={`report-page ${noBorder ? 'no-border' : ''}`}>
      {children}
    </main>
  </div>
);

export default Container;
